import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ImageViewer from 'react-simple-image-viewer'; // Import ImageViewer
import '../style.css'; // Ensure you have the necessary styles
import PurchaseMedia from './modal/PurchaseMedia';

function ViewMultimedia() {
    const { id } = useParams();
    const [media, setMedia] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isViewerOpen, setIsViewerOpen] = useState(false); // State to control the viewer
    const [currentImageIndex, setCurrentImageIndex] = useState(0); // State for the current image index
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [discipline, setDiscipline] = useState("");
    const [userId, setUserId] = useState("");
    const [author, setAuthor] = useState("");
    const [showPurchase, setShowPurchase] = useState("");
    const [purchasedMedia, setPurchasedMedia] = useState([]);

    useEffect(() => {
        const fetchUserPurchase = async () => {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                const response = await axios.get(`https://geoid-rest.vercel.app/users/${user.user._id}`);
                setPurchasedMedia(response.data.media);
            } catch (error) {
                console.error("There was an error fetching the models!", error);
            }
        }

        fetchUserPurchase();
    },[])

    useEffect(() => {
        const fetchMedia = async () => {
            try {
                const response = await axios.get(`https://geoid-rest.vercel.app/media/${id}`);
                setMedia(response.data);
                setUserId(response.data.userId);
            } catch (error) {
                console.error('Error fetching media:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchMedia();
    }, [id]);

    useEffect(() => {
        const fetchAuthor = async () => {
            try {
                const response = await axios.get(`https://geoid-rest.vercel.app/users/${userId}`);
                setAuthor(response.data.display_name);
            } catch (error) {
                console.error("There was an error fetching the models!", error);
            }
        }

        fetchAuthor();
    },[])

    useEffect(() => {
        if (media && media.category) {
            if (media.category.toLowerCase() === 'archaeology'){
                setDiscipline("Archaeology")
            } else if (media.category.toLowerCase() === 'gall') {
                setDiscipline("Geology - All")
            } else if (media.category.toLowerCase() === 'geology') {
                setDiscipline("Geology - All")
            } else if (media.category.toLowerCase() === 'ggeneral') {
                setDiscipline("Geology - General")
            } else if (media.category.toLowerCase() === 'gong') {
                setDiscipline("Geology - Oil & Gas")
            } else if (media.category.toLowerCase() === 'gmining') {
                setDiscipline("Geology - Mining")
            } else if (media.category.toLowerCase() === 'gengineering') {
                setDiscipline("Geology - Engineering/Geotechnical")
            } else if (media.category.toLowerCase() === 'genvironment') {
                setDiscipline("Geology - Environment")
            }
        }
    }, [media])

    if (loading) {
        return <div className="loading-screen"><p>Loading media...</p></div>;
    }

    if (!media) {
        return <div>No media found.</div>;
    }

    const openImageViewer = () => {
        setIsViewerOpen(true); // Open the image viewer
    };

    const closeImageViewer = () => {
        setIsViewerOpen(false); // Close the image viewer
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const fetchUserPurchase = async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const response = await axios.get(`https://geoid-rest.vercel.app/users/${user.user._id}`);
            setPurchasedMedia(response.data.media);
        } catch (error) {
            console.error("There was an error fetching the models!", error);
        }
    }

    const handleCloseModal = () => {
        setShowPurchase(false);
        fetchUserPurchase();
    };

    const handlePurchaseClick = (data) => {
        setShowPurchase(true);
    };

    const handleDownload = async () => {
        try {
            const response = await fetch(media.imgSrc);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            
            const a = document.createElement('a');
            a.href = url;
            a.download = media.name || 'downloaded-media'; // Set the filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url); // Clean up
        } catch (error) {
            console.error('Error downloading the media:', error);
        }
    };

    return (
        <div style={{
            width: '100%', 
            display: 'flex', 
            justifyContent: "center", 
            flexDirection: "column",
            alignItems: "center"
        }}>
            <div className="media-container">
                {media.type === "video" ? (
                    <video controls src={media.imgSrc} className="media-player" />
                ) : (
                    <div className="image-wrapper" onClick={openImageViewer}> {/* Open viewer on click */}
                        <img src={media.imgSrc} alt={media.name} className="media-image" />
                        <div className="media-overlay">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
                                <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
                                <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"/>
                            </svg>
                            <span>Click for Fullscreen</span>
                        </div>
                    </div>
                )}
            </div>
            <div className="media-details">
                <h2>{media.name}</h2>
                <p><strong>Location:</strong> {media.location || "-"}</p>
                <p><strong>Category:</strong> {media.category || "-"}</p>
                {media.category.toLowerCase() === 'geology' && (
                    <>
                        <p><strong>Formation:</strong> {media.formation || "-"}</p>
                        <p><strong>Rock Type:</strong> {media.rockType || "-"}</p>
                        <p><strong>Major Lithology:</strong> {media.majorLithology || "-"}</p>
                        <p><strong>Age:</strong> {media.age || "-"}</p>
                    </>
                )}
                {media.category.toLowerCase() === 'archaeology' && (
                    <>
                        <p><strong>Origin:</strong> {media.origin || "-"}</p>
                        <p><strong>Excavation Site:</strong> {media.excavation || "-"}</p>
                        <p><strong>Age / Historical Period:</strong> {media.age || "-"}</p>
                    </>
                )}
                <p><strong>Latitude/Longitude:</strong> {`${media.lat}, ${media.long}` || "-"}</p>
                <div className='button-group'>
                    <button className="view-model-btn" onClick={toggleModal}>View Media Details</button>
                    <button className="download-model-btn" onClick={handlePurchaseClick}>Purchase</button>
                    { Array.isArray(purchasedMedia) && purchasedMedia.includes(media._id) ? (
                        <a href={media.imgSrc} download style={{textDecoration: 'none'}}><button className="download-model-btn">Download Media</button></a>
                    ): null}
                </div>

                {isModalOpen &&(
                    <div className="modal-overlay">
                        <div className="modal-content-info">
                            <div className="detail-group">
                                <p><strong>Author</strong></p>
                                <p style={{textAlign: 'right'}}>{author}</p>
                            </div>
                            <hr />
                            <div className="detail-group">
                                <p><strong>Country</strong></p>
                                <p style={{textAlign: 'right'}}>{media.country}</p>
                            </div>
                            <hr />
                            <div className="detail-group">
                                <p><strong>State</strong></p>
                                <p style={{textAlign: 'right'}}>{media.state}</p>
                            </div>
                            <hr />
                            <div className="detail-group">
                                <p><strong>District</strong></p>
                                <p style={{textAlign: 'right'}}>{media.district}</p>
                            </div>
                            <hr />
                            <div className="detail-group">
                                <p><strong>City/Placemark</strong></p>
                                <p style={{textAlign: 'right'}}>{media.city}</p>
                            </div>
                            <hr />
                            <div className="detail-group">
                                <p><strong>Discipline</strong></p>
                                <p style={{textAlign: 'right'}}>{discipline}</p>
                            </div>
                            <hr />
                            {media.category !== "Archaeology" && (
                                <>
                                    <div className="detail-group">
                                        <p><strong>Formation</strong></p>
                                        <p style={{textAlign: 'right'}}>{media.formation}</p>
                                    </div>
                                    <hr />
                                    <div className="detail-group">
                                        <p><strong>Rock Type</strong></p>
                                        <p style={{textAlign: 'right'}}>{media.rockType}</p>
                                    </div>
                                    <hr />
                                    <div className="detail-group">
                                        <p><strong>Major Lithology</strong></p>
                                        <p style={{textAlign: 'right'}}>{media.majorLithology}</p>
                                    </div>
                                    <hr />
                                    <div className="detail-group">
                                        <p><strong>Age</strong></p>
                                        <p style={{textAlign: 'right'}}>{media.age}</p>
                                    </div>
                                    <hr />
                                    <div className="detail-group">
                                        <p><strong>Fossil</strong></p>
                                        <p style={{textAlign: 'right'}}>{media.fossil}</p>
                                    </div>
                                </>
                            )}

                            {media.category === "Archaeology" && (
                                <>
                                    <div className="detail-group">
                                        <p><strong>Origin</strong></p>
                                        <p style={{textAlign: 'right'}}>{media.origin}</p>
                                    </div>
                                    <hr />
                                    <div className="detail-group">
                                        <p><strong>Excavation</strong></p>
                                        <p style={{textAlign: 'right'}}>{media.excavation}</p>
                                    </div>
                                    <hr />
                                    <div className="detail-group">
                                        <p><strong>Age</strong></p>
                                        <p style={{textAlign: 'right'}}>{media.age}</p>
                                    </div>
                                </>
                            )}   
                            <hr />
                            <div className="detail-group">
                                <p><strong>Latitude , Longitude</strong></p>
                                <p style={{textAlign: 'right'}}>{media.latitude} , {media.longitude}</p>
                            </div>
                            <hr />

                            {/* Close Button */}
                            <button onClick={toggleModal} className="close-modal-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stack" viewBox="0 0 16 16">
                                    <path d="m14.12 10.163 1.715.858c.22.11.22.424 0 .534L8.267 15.34a.6.6 0 0 1-.534 0L.165 11.555a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.6.6 0 0 1 .534 0l7.568 3.784a.3.3 0 0 1 0 .535L8.267 8.165a.6.6 0 0 1-.534 0L.165 4.382a.299.299 0 0 1 0-.535z"/>
                                    <path d="m14.12 6.576 1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.6.6 0 0 1-.534 0L.165 7.968a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0z"/>
                                </svg>
                                <p>BACK TO 3D MODEL</p>
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Render ImageViewer */}
            {isViewerOpen && (
                <ImageViewer
                    src={[media.imgSrc]} // Pass the image source as an array
                    currentIndex={currentImageIndex} // Current image index
                    onClose={closeImageViewer} // Function to close the viewer
                    backgroundStyle={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 3000 }} // Optional: background style
                />
            )}

            {showPurchase && (
                    <PurchaseMedia
                        show={showPurchase}
                        media={media}
                        onClose={handleCloseModal}
                        purchasedMedia={purchasedMedia}
                        author={author}
                    />
                )}
        </div>
    );
}

export default ViewMultimedia;